import React, { useState } from 'react'
import styles from './FilterInner-styles'
import Checkbox from 'blocks.simple/checkbox/checkbox'
import translate from '../../../core/translate'
import Button from 'blocks.simple/button/button'
import { cn } from 'ethcss'
import { IFilter, IFilterChange, Option } from '../Filter/Filter-types'
import DotTooltip from 'blocks.simple/dotTooltip/dotTooltip'
import { getValidNameLabel } from 'core/helpers/filters'

interface IFilterInnerProps {
    filter: IFilter
    changeVariant: (filter: IFilterChange) => void
    multiselect: (filterName: string, selected: boolean) => void
    onApply?: () => void
    onClose?: () => void
    containerClassName?: string
}

export const FilterInner = ({ filter, changeVariant, multiselect, onApply, containerClassName }: IFilterInnerProps) => {
    const [searchValue, setSearchValue] = useState('')

    const tooltip = (label: string) => {
        return (
            <DotTooltip tooltip={{ html: label }}>
                <div className={styles.tooltip} dangerouslySetInnerHTML={{ __html: label }} />
            </DotTooltip>
        )
    }

    return (
        <div className={cn(containerClassName, styles.filterInner)}>
            <div className={styles.searchBlock}>
                <input
                    className={styles.searchInput}
                    type={'text'}
                    placeholder={translate('searchByOptions')}
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                />
            </div>
            <div className={styles.multiSelect}>
                <div className={styles.selectBtn} onClick={() => multiselect(filter.name, true)}>
                    {translate('selectAll')}
                </div>
                <div className={styles.selectBtn} onClick={() => multiselect(filter.name, false)}>
                    {translate('reset')}
                </div>
            </div>
            <div className={styles.filterValues}>
                {filter.options
                    .filter((option: Option) =>
                        translate(option.label.toLowerCase()).includes(searchValue.toLowerCase())
                    )
                    .map((optionItem: Option, index: number) => {
                        const label = getValidNameLabel(optionItem, filter.translateOptionsQ)
                        return (
                            <Checkbox
                                key={index}
                                onClick={() =>
                                    changeVariant({
                                        name: filter.name,
                                        option: {
                                            value: optionItem.value,
                                            selected: !optionItem.selected,
                                            label: optionItem.label,
                                        },
                                    })
                                }
                                checked={optionItem.selected}
                                label={tooltip(label)}
                                labelClassName={styles.label}
                                wrapperClassName={styles.checkbox}
                                style={{ position: 'absolute', top: 0, left: 0 }}
                            />
                        )
                    })}
            </div>
            {!containerClassName && (
                <Button onClick={onApply} className={styles.applyBtn} mod="fill">
                    {translate('apply')}
                </Button>
            )}
        </div>
    )
}
